/* global $ */
import intl from 'react-intl-universal'

import {
  getCurrentCursorIndex,
  findFocusCursor,
} from '../composeBody/copypaste.js'
import { splitHTMLAtIndex } from '../../util/htmlAttrs'
import { getStoryOperationInProgress } from '~/redux/appReducer'

function workflowBarController(
  $scope,
  $rootScope,
  $location,
  storyService,
  storyTemplateService,
  $timeout,
  $ngRedux
) {
  this.intl = intl

  /**
   * Intentionally bypassing isStatefulDraftApi check
   * Will be removed as part of https://arcpublishing.atlassian.net/browse/COMP-4911
   */
  this.isStatefulEnabled = false

  this.isTemplatePage = $location.path() === '/template'
  this.isStoryCreationPage = $location.path() === '/story'
  this.templateId = $location.search().template

  const ngReduxUnsubscribe = $ngRedux.connect((state) => ({
    isStoryOperationInProgress: getStoryOperationInProgress(state),
  }))(this)

  $scope.$on('$destroy', () => {
    ngReduxUnsubscribe()
  })

  this.showWebskedBtns = () => {
    return (
      !this.isTemplatePage &&
      this.lockObj.isMyLock &&
      !this.lockObj.readonly &&
      !$rootScope.globalSettings.disableWebskedIntegration
    )
  }

  this.backToTemplates = () => {
    window.location.href = `${window.location.origin}/composer/templates/v2`
  }

  this.cancelCreateStory = () => {
    history.back()
  }

  this.saveTemplate = () => {
    //  ML: this resolves EL-1739 where textbox/dropdown fields in templates were not being saved properly
    $rootScope.story = storyService.get()

    storyTemplateService
      .save()
      .then(() => {
        storyService.isDirty(false)
        this.backToTemplates()
      })
      .catch(() => {
        // Intentionally left blank to halt action if error is caught from storyTempalate.save()
      })
  }

  // company settings set in initialLoads in router folder
  this.save = ($event, closeAfterSave) => {
    const ignore = document.activeElement && document.activeElement.dataset.ipd

    if ($event && !ignore) {
      $event.preventDefault()
    }
    // Save for Story
    const ff = $('.feature-focused [contenteditablebind]').not('li')

    let setHTMLAndFocus
    const cursorPosition = ff.length ? getCurrentCursorIndex() : null
    if (cursorPosition !== null && ff.html()) {
      const orgHtml = ff.html().replace(/&nbsp;/g, ' ')
      setHTMLAndFocus = () => {
        const cursorPartials = splitHTMLAtIndex(orgHtml, cursorPosition)
        ff.html(
          cursorPartials.lead +
            '<span class="cursor-focus-back"></span>' +
            cursorPartials.tail
        )
        console.log('setting it to: ', ff.html())
        findFocusCursor('span.cursor-focus-back')
      }
    }

    ff.trigger('change').trigger('custChange')

    $timeout(function () {
      if (closeAfterSave) {
        storyService.saveAndRedirect('search')
      } else {
        if (setHTMLAndFocus) {
          const newPos = getCurrentCursorIndex()
          if (newPos === 0 && newPos !== cursorPosition) {
            setHTMLAndFocus()
          }
        }
        storyService.save($rootScope.companySettings)
      }
    }, 0)
  }

  // TODO: ERIC - BIND THIS ANGULAR
  $(window)
    .off('keydown.save')
    .on('keydown.save', (e) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        e.which === 83 &&
        this.isStoryOperationInProgress === false
      ) {
        this.save(null, false)
        e.preventDefault()
      }
    })
}

export default [
  '$scope',
  '$rootScope',
  '$location',
  'storyService',
  'storyTemplateService',
  '$timeout',
  '$ngRedux',
  workflowBarController,
]
